import { coercedDate } from '../../../utils/coerced-date';
import { z } from 'zod/v4';

export const vehicleGroupSchema = z.object({
  vehicleGroupId: z.number(),
  isAllVehiclesGroup: z.boolean().optional(),
  vehicleGroupName: z.string(),
  numberOfVehicles: z.number().optional(),
  numberOfRoutingProfiles: z.number().optional(),
  hasConfigurationSettings: z.boolean().optional(),
  hasSpeedCoachingProfile: z.boolean().optional(),
  numberOfMapSets: z.number().optional(),
  numberOfRouteModifiers: z.number().optional(),
  numberOfPlaceSets: z.number().optional(),
  oorEmail: z.string().nullable().optional(),
  oorEmailIsEnabled: z.boolean().optional(),
  modifiedOn: coercedDate,
  criticalMapUpdateVersion: z.number().optional().nullable(),
});

export type VehicleGroup = z.infer<typeof vehicleGroupSchema>;

export const simpleVehicleGroupSchema = vehicleGroupSchema.pick({
  vehicleGroupId: true,
  vehicleGroupName: true,
});

export type SimpleVehicleGroup = z.infer<typeof simpleVehicleGroupSchema>;
